import {Component, Input, OnInit} from "@angular/core";
import {
    Aangifte, AangifteRapport, BokkzAlgDataService,
    IncomeTaxEntity, OpbouwWUO, SpecificatieWUO,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, combineLatest,} from "rxjs";
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiButtonModule } from '@snelstart/ui-button';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-beginvermogen',
  templateUrl: './spec-beginvermogen.component.html',
  styleUrls: ['./spec-beginvermogen.component.scss'],
  imports: [
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiDialogModule,
    SharedUiButtonModule
  ]
})

export class SpecBeginvermogenComponent implements OnInit {
    @Input() public id!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = {} as boolean;
    public partnerAangifte = {} as Aangifte;

    public focusedElementId: string | null = null;
    public dialogVisible = false;

    rapportFormGroup = this.fb.group<AangifteRapport>({});
    rapport = {} as AangifteRapport;
    partnerRapport = {} as AangifteRapport;
    aangifteRapport = {} as AangifteRapport;
    public eigenVermogenFg = {} as FormGroup;

    public formStructure: any;

    showDialog() {
        this.dialogVisible = true;
    }

    constructor(private fb: FormBuilder,
                public dataService: BokkzIbDataService,
                public dataAlgService: BokkzAlgDataService) {
        this.rapportFormGroup = this.fb.group<AangifteRapport>(({
            specificatieWuo: this.fb.group<SpecificatieWUO>(({
                opbouw: this.fb.group<OpbouwWUO>(({
                    beginstandKER: null as unknown as number,
                    beginstandHIR: null as unknown as number,
                    beginstandFOR: null as unknown as number,
                    totaleBeginvermogen: null as unknown as number,
                } as OpbouwWUO))
            } as SpecificatieWUO))
        } as AangifteRapport));
        this.eigenVermogenFg = this.fb.group({
            eigenVermogenBeginstand: null as unknown as number,
        });
    }

    public ngOnInit(): void {
        combineLatest([
            this.dataService.incomeTaxEntity,
            this.dataService.aangifteRapport,
            this.dataService.partnerAangifteRapport,
        ]).subscribe(([incomeTaxEntity, aangeverRapport, partnerRapport]) => {
            this.rapportFormGroup.reset(); // Form resetten voordat nieuwe data wordt gepatcht

            if (incomeTaxEntity) {
                this.incomeTaxEntity = incomeTaxEntity;

                if (aangeverRapport) {
                    this.aangifteRapport = aangeverRapport;
                }
                if (partnerRapport) {
                    this.partnerRapport = partnerRapport;
                }
            }

            if (incomeTaxEntity.aangifte) {
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner;
                    this.rapportFormGroup.reset(); // Reset opnieuw, maar daarna wél patchen!

                    const selectedRapport = partner ? this.partnerRapport : this.aangifteRapport;

                    this.rapportFormGroup.patchValue({
                        specificatieWuo: {
                            opbouw: {
                                beginstandKER: ((selectedRapport.specificatieWUO?.opbouw?.eindstandKER || 0) - (selectedRapport.specificatieWUO?.opbouw?.dotatieKER || 0) + (selectedRapport.specificatieWUO?.opbouw?.vrijvalKER || 0)),
                                beginstandHIR: ((selectedRapport.specificatieWUO?.opbouw?.eindstandHIR || 0) - (selectedRapport.specificatieWUO?.opbouw?.dotatieHIR || 0) + (selectedRapport.specificatieWUO?.opbouw?.vrijvalHIR || 0)),
                                beginstandFOR: ((selectedRapport.specificatieWUO?.opbouw?.eindstandFOR || 0) - (selectedRapport.specificatieWUO?.opbouw?.dotatieFOR || 0) + (selectedRapport.specificatieWUO?.opbouw?.vrijvalFOR || 0)),
                                totaleBeginvermogen: selectedRapport.specificatieWUO?.opbouw?.totaleBeginvermogen || 0,
                            }
                        }
                    });
                    this.eigenVermogenFg.patchValue({
                        eigenVermogenBeginstand: (selectedRapport.specificatieWUO?.opbouw?.totaleBeginvermogen || 0) -
                            ((selectedRapport.specificatieWUO?.opbouw?.eindstandKER || 0) - (selectedRapport.specificatieWUO?.opbouw?.dotatieKER || 0) + (selectedRapport.specificatieWUO?.opbouw?.vrijvalKER || 0)) -
                            ((selectedRapport.specificatieWUO?.opbouw?.eindstandHIR || 0) - (selectedRapport.specificatieWUO?.opbouw?.dotatieHIR || 0) + (selectedRapport.specificatieWUO?.opbouw?.vrijvalHIR || 0))  -
                            ((selectedRapport.specificatieWUO?.opbouw?.eindstandFOR || 0) - (selectedRapport.specificatieWUO?.opbouw?.dotatieFOR || 0) + (selectedRapport.specificatieWUO?.opbouw?.vrijvalFOR || 0))
                    });

                });
            }
        });
        this.disableFormGroup(this.rapportFormGroup);
        this.disableFormGroup(this.eigenVermogenFg);
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}

